import { Box, Typography } from '@mui/material';
import { LoginPageStyles } from '../styles/LoginPageStyles';

const BrainPost = () => {
  return (
    <Box sx={LoginPageStyles.leftContainer}>
      <Box sx={LoginPageStyles.imageContainer}>
        <img
          src={
            'https://res.cloudinary.com/dh0eho4vx/image/upload/v1747191685/brain_lch2z5.png'
          }
          alt="brain"
          style={{ width: '200px', height: '200px', marginBottom: '20px' }}
        />
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: '4px'
        }}>
          <Typography align="center" sx={LoginPageStyles.sloganFont}>
            Trust
          </Typography>
          <Typography align="center" sx={LoginPageStyles.sloganFont}>
            your notes
          </Typography>
          <Typography align="center" sx={LoginPageStyles.sloganFont}>
            Master the practice
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BrainPost;
